<template>
    <div class="card card-widget">
        <div class="card-footer p-0">
            <ul class="nav flex-column">
                <li class="nav-item">
                    <a href="#" class="nav-link" @click.prevent="$emit('cambiar-activos')">
                        {{ $t('general.activas') }} <span class="float-right badge bg-primary">{{activos}}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link" @click.prevent="$emit('cambiar-eliminados')">
                        {{ $t('general.archivadas') }} <span class="float-right badge bg-info">{{eliminados}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    props: ['activos','eliminados'],
    components: {
        
    },
    data() {
        return {
           
        }
    },
    methods: {
        

    },
    mounted() {
    }
}
</script>